

const page          = require('../../../../../components/page/page')
const fullcontJump  = require('../../../../../components/fullcont/fullcont-jump')
const click         = require('../../../../../js/click')

export function start(detail){ 
         
      obj[detail.actJump].start(detail)

}/**/

const obj = {
      goToInvestor:        { start: (detail)=>{  goToInvestor(detail)         }},
}

function goToInvestor(detail){ 
      
   //show the page
   click.start({dest: 'investor', elem: 'page', act: 'show', id: 'investor-page'})   

   fullcontJump.searchOnPage(detail)

}/**/
